/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Text is encoded as UTF-8 first, so emoji, accents and CJK characters round-trip correctly — unlike naive btoa() which breaks on them.`)
};

const es_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El texto se codifica como UTF-8 primero, por lo que emoji, acentos y caracteres CJK se redondean correctamente — a diferencia del ingenuo btoa() que se rompe con ellos.`)
};

const de_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Text wird zuerst als UTF-8 kodiert, also Emojis, Akzente und CJK-Zeichen machen eine genaue Umwandlung — im Gegensatz zu naivem btoa() das darauf bricht.`)
};

const nl_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Tekst wordt eerst als UTF-8 gecodeerd, dus emoji, accenten en CJK-tekens ronden correct — in tegenstelling tot naïeve btoa() die erop breekt.`)
};

const fr_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le texte est d'abord codé en UTF-8, donc les emoji, les accents et les caractères CJK font des allers-retours correctement — contrairement à btoa() naïf qui se casse sur eux.`)
};

const it_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il testo viene codificato come UTF-8 prima, quindi emoji, accenti e caratteri CJK tornano indietro correttamente, a differenza di btoa() ingenuo che si rompe su di essi.`)
};

const pt_br2_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O texto é codificado como UTF-8 primeiro, então emoji, acentos e caracteres CJK fazem a volta-redonda corretamente — ao contrário do btoa() ingênuo que quebra neles.`)
};

const pt_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O texto é codificado como UTF-8 primeiro, de modo que emoji, acentos e caracteres CJK fazem ida e volta corretamente — ao contrário do btoa() ingénuo que quebra neles.`)
};

const ja_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。テキストは最初にUTF-8としてエンコードされるため、emoji、アクセント、CJK文字は正しくラウンドトリップします—単純なbtoa()がそれらを破るとは異なります。`)
};

const zh_b64_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持。文本会先编码为 UTF-8，因此表情符号、重音符号和中日韩（CJK）字符都能正确地往返转换——而简单的 btoa() 在处理这些字符时会出错。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq1_a", locale)
	if (locale === "en") return en_b64_faq1_a(inputs)
	if (locale === "es") return es_b64_faq1_a(inputs)
	if (locale === "de") return de_b64_faq1_a(inputs)
	if (locale === "nl") return nl_b64_faq1_a(inputs)
	if (locale === "fr") return fr_b64_faq1_a(inputs)
	if (locale === "it") return it_b64_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq1_a(inputs)
	if (locale === "pt") return pt_b64_faq1_a(inputs)
	if (locale === "ja") return ja_b64_faq1_a(inputs)
	return zh_b64_faq1_a(inputs)
};